import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPublicDonateEvents, DonateChallenge } from '../../api/payment/donate-challenge.api';
import { clockSkewMs, countdownLabel } from '../../utils/donate-challenge';
import usePollWhile from '../../hooks/use-poll-while/use-poll-while';

/**
 * Dải mỏng đầu trang chủ báo có sự kiện thử thách donate đang diễn ra — bấm vào xem
 * bảng xếp hạng ở `/su-kien/{id}`. Tải danh sách sự kiện công khai một lần khi mount,
 * chọn sự kiện `Running` đầu tiên; không có thì không hiện gì.
 *
 * Đếm ngược cập nhật mỗi 30 giây (dùng `clockSkewMs` để không lệch khi máy người dùng sai giờ)
 * và tự ẩn khi hết giờ — không đợi vòng tải lại kế tiếp mới biến mất.
 */
const DonateEventStrip: React.FC = () => {
  const [event, setEvent] = useState<DonateChallenge | null>(null);
  const [skewMs, setSkewMs] = useState(0);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    getPublicDonateEvents()
      .then((events) => {
        const running = events.find((e) => e.status === 'Running') || null;
        if (running) setSkewMs(clockSkewMs(running.serverNow));
        setEvent(running);
      })
      .catch(() => setEvent(null));
  }, []);

  usePollWhile(!!event, () => setNow(Date.now()), 30000);

  if (!event) return null;

  const remainingMs = new Date(event.endAt).getTime() - (now + skewMs);
  if (remainingMs <= 0) return null;

  return (
    <Link
      to={`/su-kien/${event.id}`}
      className="ui-card mb-3 flex h-10 items-center overflow-hidden px-3 text-sm"
    >
      <span className="truncate text-gray-800 dark:text-gray-100">
        🏆 Sự kiện <span className="font-semibold">{event.title}</span> · còn{' '}
        {countdownLabel('Running', remainingMs, false)} ·{' '}
        <span className="font-semibold text-[#066bff]">Xem bảng xếp hạng</span>
      </span>
    </Link>
  );
};

export default DonateEventStrip;
